import type { AxiosPromise } from 'axios';
import { type ClientContext, ContextClient } from '~/services/contextClient';
import LifecycleStatusDefinitionsClientFactory from './lifecycleStatusDefinitionsClient.factory';
import type {
    LifecycleStatusDefinitionFormData,
    LifecycleStatusDefinitionsClientInterface,
    LifecycleStatusDefinitionsResponse,
} from './lifecycleStatusDefinitionsClient.types';

class LifecycleStatusDefinitionsClient extends ContextClient<LifecycleStatusDefinitionsClientInterface> {
    constructor() {
        super(LifecycleStatusDefinitionsClientFactory);
    }

    getLifecycleStatusDefinitions(context: ClientContext): AxiosPromise<LifecycleStatusDefinitionsResponse> {
        const client = this.getClient(context);
        return client.getLifecycleStatusDefinitions();
    }

    updateLifecycleStatusDefinitions(
        context: ClientContext,
        data: { definitions: LifecycleStatusDefinitionFormData[] },
        extraConfig?: { cancelKey?: string | symbol }
    ): AxiosPromise<LifecycleStatusDefinitionsResponse> {
        const client = this.getClient(context);
        return client.updateLifecycleStatusDefinitions(data, extraConfig);
    }
}

export default new LifecycleStatusDefinitionsClient();
